<div class="col-12">
    <div class="col-12">
        <app-shared-partner
            [formatType]="'BNTENNISTOOL02'"
            [position]="'NEWS_START'"
            [direction]="'horizontal'"
        ></app-shared-partner>
    </div>
</div>
<div class="container">
    <div class="page">
        <ng-container *ngIf="news">
            <h1 class="title">{{ news.title }}</h1>
            <hr class="divider" />
            <h2 class="subtitle">{{ news.sub_title }}</h2>
            <ngx-glide
                [perView]="1"
                [showArrows]="true"
                [showBullets]="true"
                [arrowLeftTemplate]="arrowLeft"
                [arrowRightTemplate]="arrowRight"
                [autoplay]="5000"
                #ngxGlide
            >
                <figure class="cover" *ngFor="let image of news.images">
                    <img [src]="image?.full || 'https://via.placeholder.com/760x420'" [alt]="news.title" />
                    <figcaption *ngIf="image.caption_photo || image.photo_credit">
                        <span>{{ image.caption_photo }}</span>
                        <span> | </span>
                        <!-- prettier-ignore -->
                        <span>© {{ image.photo_credit }}</span>
                    </figcaption>
                </figure>
            </ngx-glide>
            <div class="content">
                <div class="meta">
                    <div class="author">
                        <img [src]="news.author.url_avatar" />
                        <span>{{ news.author["name"] }}</span>
                    </div>
                    <span class="date">{{ news.dt_post }}</span>
                </div>

                <div [innerHTML]="news.text"></div>
                <div class="footer" [innerHTML]="news.texto_footer" *ngIf="news.texto_footer"></div>
                <ng-template [ngIf]="window.innerWidth <= 575" [ngIfElse]="static">
                    <ngx-glide
                        [perView]="1"
                        [showArrows]="false"
                        [showBullets]="false"
                        [autoplay]="3000"
                        class="partners"
                    >
                        <div class="col-sm-3" *ngFor="let partner of news.shared_news_partners">
                            <img [src]="partner.url_logo" class="img-responsive" />
                        </div>
                    </ngx-glide>
                </ng-template>
                <ng-template #static>
                    <div class="row partners">
                        <div class="col-sm-3" *ngFor="let partner of news.shared_news_partners">
                            <img [src]="partner.url_logo" class="img-responsive" />
                        </div>
                    </div>
                </ng-template>
            </div>
            <div class="col-12">
                <div class="col-12">
                    <app-shared-partner
                        [formatType]="'BNTENNISTOOL03'"
                        [position]="'NEWS_END'"
                        [direction]="'horizontal'"
                    ></app-shared-partner>
                </div>
            </div>
        </ng-container>
    </div>
</div>

<ng-template #arrowLeft>
    <button nbButton class="slide-arrow slide-arrow--left"><nb-icon icon="arrow-ios-back-outline"></nb-icon></button>
</ng-template>
<ng-template #arrowRight>
    <button nbButton class="slide-arrow slide-arrow--right">
        <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
    </button>
</ng-template>
